import { Component, ElementRef, EventEmitter, Input, NgModule, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ScheduleOptionsProp } from '../models/Exam';
import { QuestionserviceService } from '../services/questionservice.service';

@Component({
  selector: 'app-option-check',
  templateUrl: './option-check.component.html',
  styleUrls: ['./option-check.component.scss']
})
export class OptionCheckComponent implements OnInit {

  @Input() option: ScheduleOptionsProp;
  @Output() checkchanged: EventEmitter<ScheduleOptionsProp> = new EventEmitter();
  @Input() schedulequestionid: number;
  @ViewChild('optionCheckhtmlspan') optionCheckhtmlspan: ElementRef;
  
  ngOnInit(): void {
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    this.setOption();
  }
  ngAfterViewInit(): void {
    this.setOption();
  }

  setOption() {
    if (this.optionCheckhtmlspan) {
      if (this.option) {
        this.optionCheckhtmlspan.nativeElement.innerHTML = this.option.optionhtml;
        this.optionCheckhtmlspan.nativeElement = QuestionserviceService.cleanMathFieldValues(this.optionCheckhtmlspan.nativeElement);
      }
      else {
        this.optionCheckhtmlspan.nativeElement.innerHTML = '';
      }
    }
  }

  checkChanged(e, option: ScheduleOptionsProp) {
    //this.disableradios()
    if (e.target.checked) {
      option.selected = true;
    }
    else {
      option.selected = false;
    }

    this.checkchanged.emit(option);
  }
  // disableradios() {
  //   var buttons = document.getElementsByClassName(this.schedulequestionid.toString());
  //   for (var i = 0; i < buttons.length; i++) {
  //     this.radiodiabbletoggle(buttons[i]);
  //   }
  // }
  // radiodiabbletoggle(button) {
  //   button.disabled = true;
  // }
}
